export const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

export function getAssetUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  if (/^https?:\/\//i.test(API_BASE_URL)) return `${API_BASE_URL}${path}`;
  return path;
}

export async function fetchPortfolioData() {
  const response = await fetch(`${API_BASE_URL}/portfolio`);

  if (!response.ok) {
    throw new Error(`Unable to load portfolio data (${response.status})`);
  }

  return response.json();
}

export async function loginAdmin(credentials) {
  const response = await fetch(`${API_BASE_URL}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(credentials),
  });

  if (!response.ok) {
    throw new Error(response.status === 401 ? "Invalid admin credentials" : "Unable to log in");
  }

  return response.json();
}

export async function savePortfolioData(data, token) {
  const headers = { "Content-Type": "application/json" };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}/portfolio`, {
    method: "PUT",
    headers,
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const message = response.status === 401 || response.status === 403
      ? "Admin login required"
      : `Unable to save portfolio data (${response.status})`;
    throw new Error(message);
  }

  return response.json();
}

export async function uploadResume(file, token) {
  const formData = new FormData();
  formData.append("resume", file);

  const headers = {};

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}/portfolio/resume`, {
    method: "POST",
    headers,
    body: formData,
  });

  if (!response.ok) {
    const message = response.status === 401 || response.status === 403
      ? "Admin login required"
      : `Unable to upload resume (${response.status})`;
    throw new Error(message);
  }

  return response.json();
}
